/**
 * На какой пол ляжет покрытие из панели «Отделка»: выделенная комната. Выделена стена —
 * комната, в которую смотрит её выбранная сторона (та, что ближе к пользователю в 3D).
 */
import type { RoomFloor } from "@/shared/plan";
import { useProjectStore } from "@/shared/store";
import { SelectionKind, useEditorStore } from "@/widgets/editor";
import { detectRooms, roomOfFace, type Room } from "@/widgets/plan";

export interface FloorTarget {
	room: Room;
	/** «Пол · Помещение 2» */
	label: string;
	/** Покрытие комнаты; нет — не назначено */
	floor: RoomFloor | undefined;
}

export const useFloorTarget = (): FloorTarget | null => {
	const selection = useEditorStore((s) => s.selection);
	const graph = useProjectStore((s) => s.project.layers.walls);
	const floors = useProjectStore((s) => s.project.layers.floors.items);
	if (!selection) return null;

	const rooms = detectRooms(graph);
	let room: Room | null = null;
	if (selection.kind === SelectionKind.Room) {
		room = rooms.find((r) => r.id === selection.id) ?? null;
	} else if (selection.kind === SelectionKind.Wall && graph.walls[selection.id]) {
		// Сторона стены — как в отделке стен: выбранная или та, что смотрит в комнату
		const sides = ([1, -1] as const).map((side) =>
			roomOfFace(graph, rooms, { wallId: selection.id, side }),
		);
		room =
			(selection.side !== undefined ? sides[selection.side === 1 ? 0 : 1] : null) ??
			sides.find(Boolean) ??
			null;
	}
	if (!room) return null;

	const index = rooms.indexOf(room);
	return { room, label: `Пол · Помещение ${index + 1}`, floor: floors[room.id] };
};
